import type { TableQuery, GroupMailTableQuery } from 'owa-mail-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { isGroupSearch } from './isGroupTableQuery';

export default function getGroupMailboxInfoFromTableQuery(
    groupId: string,
    tableQuery: TableQuery
): MailboxInfo {
    const userID = isGroupSearch(tableQuery)
        ? getModuleContextMailboxInfo().userIdentity
        : (tableQuery as GroupMailTableQuery).mailboxInfo.userIdentity;

    /* eslint-disable-next-line owa-custom-rules/require-mailbox-info-package -- (https://aka.ms/OWALintWiki)
     * To create a MailboxInfo object deep import and call the getMailboxInfoFor* function for the type of MailboxInfo you are creating.
     *	> MailboxInfo must be obtained from the owa-mailbox-info package. */
    const groupMailboxInfo: MailboxInfo = {
        type: 'GroupMailbox',
        userIdentity: userID,
        mailboxSmtpAddress: groupId,
    };

    return groupMailboxInfo;
}
